import { useMutation, useQueryClient } from '@tanstack/react-query';

import { $apiWithoutClient, errorHandler, globalConst } from 'modules/global';

export function useCheckLimit() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (type?: string) => {
      const { data } = await $apiWithoutClient.post(`/heart/check-limit?type=${type}`);

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [globalConst.queryKeys.GET_HEART_DATA] });
    },
    onError: errorHandler()
  });
}
